import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from ".";

type Clock = {
  appointmentId: string;
  employeeId: string;
  initialTime: number;
  currentTime: number;
  isRunning: boolean;
  isPaused: boolean;
  lastEventTimestamp: string | null;
};

type ClockState = {
  clocks: Record<string, Clock>;
};

const initialState: ClockState = {
  clocks: {},
};

export const clockSlice = createSlice({
  name: "clock",
  initialState,
  reducers: {
    setClock(state, action: PayloadAction<Clock>) {
      state.clocks[action.payload.appointmentId] = action.payload;
    },

    tick(state, action: PayloadAction<string>) {
      const clock = state.clocks[action.payload];

      if (clock?.isRunning) {
        clock.currentTime += 1;
      }
    },

    pauseClock(state, action: PayloadAction<string>) {
      const clock = state.clocks[action.payload];

      if (clock) {
        clock.isRunning = false;
        clock.isPaused = true;
      }
    },

    resumeClock(state, action: PayloadAction<string>) {
      const clock = state.clocks[action.payload];

      if (clock) {
        clock.isRunning = true;
        clock.isPaused = false;
      }
    },

    resetClock(state, action: PayloadAction<string>) {
      delete state.clocks[action.payload];
    },

    resetState() {
      return { ...initialState };
    },
  },
});

export const selectClock = (state: RootState, appointmentId: string) =>
  state.clock.clocks[appointmentId];

export const checkIsRunning = (
  state: RootState,
  appointmentId: string,
  employeeId: string
) => {
  const clock = state.clock.clocks[appointmentId];

  return (
    clock?.employeeId === employeeId &&
    clock.isRunning &&
    clock.appointmentId === appointmentId
  );
};

export const checkIsPaused = (
  state: RootState,
  appointmentId: string,
  employeeId: string
) => {
  const clock = state.clock.clocks[appointmentId];

  return (
    clock?.employeeId === employeeId &&
    clock.isPaused &&
    clock.appointmentId === appointmentId
  );
};
export const clockActions = clockSlice.actions;
